<template>
    <div class="dropdown">
        <button class="btn btn-outline-medium-gray btn-outline-light w-100 dropdown-toggle" type="button" id="sorting" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{$t('category.sorting.title')}} ...
        </button>
        <div class="dropdown-menu" aria-labelledby="sorting">
            <a
              href="#"
              :key="item.type"
              v-for="(item, index) in types"
              @click.prevent="sorting({ sort: item.type})"
              :class="['dropdown-item', {active: item.type === sort || (sort == null && index == 0)}]">
                <span v-if="item.name == 'Najnovejši naprej'">{{$t('category.sorting.new')}}</span>
                <span v-if="item.name == 'Zadnje dodani'">{{$t('category.sorting.latest')}}</span>
                <span v-if="item.name == 'Cena od najmanjše'">{{$t('category.sorting.priceLow')}}</span>
                <span v-if="item.name == 'Cena od največje'">{{$t('category.sorting.priceHigh')}}</span>
            </a>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapState, mapActions } = createNamespacedHelpers('filters')

export default {

  data () {
    return {
      types: [
        { name: 'Najnovejši naprej', type: 'new_date-desc' },
        { name: 'Zadnje dodani', type: 'last_change-desc' },
        { name: 'Cena od najmanjše', type: 'price-asc' },
        { name: 'Cena od največje', type: 'price-desc' }
      ]
    }
  },

  computed: mapState(['sort']),

  methods: mapActions(['sorting'])

}
</script>
